export default __webpack_public_path__ + "static/media/next-button-arrow.986fe71d.svg";